import { scrollTo } from "@/components/Header";
import { useLang } from "@/i18n";
import { FileDown } from "lucide-react";

export default function Footer() {
  const { t } = useLang();
  const links = [
    ["#tecnologia", t.nav.tecnologia],
    ["#applicazioni", t.nav.applicazioni],
    ["#finanza", t.nav.finanza],
    ["#startup", t.nav.startup],
    ["#faq", t.nav.faq],
    ["#contatti", t.footer.contact],
  ];
  const lang2 = t.footer.site === "Sito" ? "it" : "en";
  const legalLabel = { privacy: lang2 === "it" ? "Privacy Policy" : "Privacy Policy", termini: lang2 === "it" ? "Termini e Condizioni" : "Terms & Conditions" };

  return (
    <footer className="bg-[#0a0b0c] border-t border-white/10 py-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row justify-between gap-12">
          <div>
            <img src="/assets/logo.png" alt="VPS Group" className="h-14 w-auto mb-5" data-testid="footer-logo" />
            <p className="font-display font-bold text-5xl sm:text-6xl tracking-tighter" data-testid="footer-brand">
              VPS<span className="text-volt">.</span>GROUP
            </p>
            <p className="mt-4 text-sm text-steel max-w-sm leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>
          <div className="flex gap-16 text-sm">
            <div className="space-y-3">
              <p className="text-xs uppercase tracking-[0.2em] text-steel/60">{t.footer.site}</p>
              {links.map(([href, label]) => (
                <button key={href} onClick={() => scrollTo(href)} className="block text-steel hover:text-volt transition-colors" data-testid={`footer-link-${href.slice(1)}`}>
                  {label}
                </button>
              ))}
            </div>
            <div className="space-y-3">
              <p className="text-xs uppercase tracking-[0.2em] text-steel/60">{t.footer.contact}</p>
              <a href="mailto:info@vpsgroupsrl.com" className="block text-steel hover:text-volt transition-colors" data-testid="footer-email-link">info@vpsgroupsrl.com</a>
              <p className="text-steel">{t.form.location}</p>
              <a href="/privacy" className="block text-steel hover:text-volt transition-colors" data-testid="footer-privacy-link">{legalLabel.privacy}</a>
              <a href="/termini" className="block text-steel hover:text-volt transition-colors" data-testid="footer-terms-link">{legalLabel.termini}</a>
            </div>
          </div>
        </div>
        <div className="mt-14 glass rounded-2xl p-7 flex flex-col sm:flex-row sm:items-center justify-between gap-5" data-testid="footer-download-strip">
          <div>
            <p className="font-display font-semibold text-lg"><span className="text-volt">Diamond Sky</span> — Diamond SKY 50</p>
            <p className="mt-1 text-sm text-steel">{t.footer.reportText}</p>
          </div>
          <a href="/assets/relazione-tecnica-sondag.pdf" target="_blank" rel="noopener noreferrer" className="btn-primary shrink-0" data-testid="footer-download-button">
            <FileDown size={16} /> {t.tech.download}
          </a>
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-steel/60">
          <p>{t.footer.rights}</p>
          <p>{t.footer.note}</p>
        </div>
      </div>
    </footer>
  );
}
